<template>
    <Head :title="__('Edit') + ' ' + user.name"/>

    <BreezeDashboardLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ __('Edit') }} {{ user.name }}
            </h2>
        </template>

        <notification v-if="success" color="success">
            {{ success }}
        </notification>

        <card-component @submit.prevent="submit" form>

            <field class="max-w-sm" :label="__('Name')" :error="errors.name ?? ''">
                <control :icon="mdiAccount" :placeholder="__('Name')" v-model="form.name"
                         :required="true"/>
            </field>

            <field class="max-w-sm" :label="__('Email')" :error="errors.email ?? ''">
                <control :icon="mdiAt" :placeholder="__('Email')" v-model="form.email"
                         :required="true"/>
            </field>

            <field class="max-w-sm" :label="__('Password')" :error="errors.password ?? ''">
                <control :icon="mdiFormTextboxPassword" :placeholder="__('Password')" v-model="form.password"/>
            </field>

            <field class="max-w-sm" :label="__('Role')" :error="errors.role ?? ''">
                <control :icon="mdiAccountMultipleOutline" :options="role_options" v-model="form.role"
                         :required="true"/>
            </field>

            <jb-buttons class="justify-end ml-3 md:ml-0" mb="">
                <jb-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
                           type="success" color="success" :label="__('Save')"/>
                <jb-button type="button" color="danger" outline :label="__('Delete')" @click.prevent="remove" />
            </jb-buttons>
        </card-component>
    </BreezeDashboardLayout>
</template>

<script>
import BreezeDashboardLayout from '@/Layouts/Dashboard'
import CardComponent from '@/Components/Dashboard/CardComponent'
import Notification from '@/Components/Dashboard/Notification'
import {Head, usePage} from '@inertiajs/inertia-vue3';
import {ref, reactive, computed, defineProps, toRefs} from 'vue'
import {
    mdiAt,
    mdiAccount,
    mdiAccountMultipleOutline,
    mdiEmail,
    mdiFormTextboxPassword,
    mdiLink,
    mdiOpenInNew,
    mdiPuzzleOutline,
    mdiAvTimer,
    mdiTranslate,
    mdiNumeric8BoxMultipleOutline
} from '@mdi/js'
import Field from '@/Components/Dashboard/Field'
import Control from '@/Components/Dashboard/Control'
import CheckRadioPicker from '@/Components/Dashboard/CheckRadioPicker'
import JbButton from '@/Components/Dashboard/JbButton'
import JbButtons from '@/Components/Dashboard/JbButtons'
import __ from '@/trans';

export default {
    components: {
        BreezeDashboardLayout,
        Head,
        CardComponent,
        Notification,
        Field,
        Control,
        CheckRadioPicker,
        JbButton,
        JbButtons
    },
    props: {
        success: String,
        errors: Object,
        user: Object,
        roles: Object
    },
    data(props) {
        return {
            form: this.$inertia.form({
                name: props.user.name,
                email: props.user.email,
                password: '',
                role: this.role_options.find(key => key.id === props.user.roles[0].id)
            }),
        }
    },
    setup(props) {

        const role_options = []

        props.roles.forEach((role) => {
            const roleName = role.name.charAt(0).toUpperCase() + role.name.slice(1)
            role_options.push({id: role.id, label: roleName})
        })

        return {
            mdiAccount,
            mdiAccountMultipleOutline,
            mdiAt,
            mdiFormTextboxPassword,
            mdiLink,
            mdiOpenInNew,
            mdiEmail,
            mdiPuzzleOutline,
            mdiAvTimer,
            mdiTranslate,
            mdiNumeric8BoxMultipleOutline,
            role_options
        }
    },
    methods: {
        submit() {
            this.form.put(this.route('users.update', this.user.id), {
                onFinish: () => this.form.reset('name')
            })
        },
        remove() {
            this.$inertia.form({}).delete(this.route('users.destroy', this.user.id))
        }
    }
}
</script>
